import axios from "axios";
const BASE_URL = "/"

/*eslint-disable*/
export default{ BASE_URL: BASE_URL}
export const http = axios.create({
    baseURL: BASE_URL
});
